import api from './api';
import { Banner, BannerFormData } from '@/types/banner';

export const bannerApi = {
    async getAllBanners(): Promise<Banner[]> {
        try {
            const response = await api.get('/admin/banners');
            return response.data;
        } catch (error: any) {
            console.error('Error fetching banners:', error);
            throw new Error(error.response?.data?.error || 'Banner listesi yüklenemedi');
        }
    },

    async getBanner(id: string): Promise<Banner> {
        try {
            const response = await api.get(`/admin/banners/${id}`);
            return response.data;
        } catch (error: any) {
            console.error('Error fetching banner:', error);
            throw new Error(error.response?.data?.error || 'Banner yüklenemedi');
        }
    },

    async createBanner(data: BannerFormData): Promise<Banner> {
        try {
            const response = await api.post('/admin/banners', data);
            return response.data;
        } catch (error: any) {
            console.error('Error creating banner:', error);
            throw new Error(error.response?.data?.error || 'Banner oluşturulamadı');
        }
    },

    async updateBanner(id: string, data: Partial<BannerFormData>): Promise<Banner> {
        try {
            const response = await api.put(`/admin/banners/${id}`, data);
            return response.data;
        } catch (error: any) {
            console.error('Error updating banner:', error);
            throw new Error(error.response?.data?.error || 'Banner güncellenemedi');
        }
    },

    async deleteBanner(id: string): Promise<void> {
        try {
            await api.delete(`/admin/banners/${id}`);
        } catch (error: any) {
            console.error('Error deleting banner:', error);
            throw new Error(error.response?.data?.error || 'Banner silinemedi');
        }
    },

    async reorderBanners(orders: { id: string; order: number }[]): Promise<void> {
        try {
            await api.put('/admin/banners/reorder/bulk', { orders });
        } catch (error: any) {
            console.error('Error reordering banners:', error);
            throw new Error(error.response?.data?.error || 'Sıralama güncellenemedi');
        }
    },
};
